// src/pages/MetaGen.tsx
import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Input,
  Row,
  Col,
  Typography,
  Button,
  message,
  Tag,
} from "antd";
import { CopyOutlined, Html5Outlined, EyeOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { Text } = Typography;

const MetaGen: React.FC = () => {
  const [values, setValues] = useState({
    title: "",
    description: "",
    author: "",
    keywords: "",
  });

  const [code, setCode] = useState("");

  useEffect(() => {
    const generated = `<title>${values.title || "Page Title"}</title>
<meta name="description" content="${
      values.description || "Enter a description..."
    }">
<meta name="keywords" content="${values.keywords}">
<meta name="author" content="${values.author}">
<meta name="viewport" content="width=device-width, initial-scale=1.0">

<meta property="og:type" content="website">
<meta property="og:title" content="${values.title}">
<meta property="og:description" content="${values.description}">`;
    setCode(generated);
  }, [values]);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    message.success("HTML Snippet copied to clipboard!");
  };

  return (
    <Row gutter={[24, 24]}>
      {/* Configuration Panel */}
      <Col xs={24} lg={12}>
        <Card
          className="glass-card"
          title={
            <span>
              <Html5Outlined style={{ marginRight: 8, color: "#e44d26" }} />
              Configuration
            </span>
          }
          bordered={false}
        >
          <Form layout="vertical">
            <Form.Item label="Page Title">
              <Input
                placeholder="Ex: Best Gaming Laptops 2024"
                maxLength={60}
                showCount
                onChange={(e) =>
                  setValues({ ...values, title: e.target.value })
                }
              />
              <Text type="secondary" style={{ fontSize: 12 }}>
                Recommended: Keep under 60 characters
              </Text>
            </Form.Item>

            <Form.Item label="Meta Description">
              <TextArea
                placeholder="A brief summary of your page content..."
                rows={4}
                maxLength={160}
                showCount
                onChange={(e) =>
                  setValues({ ...values, description: e.target.value })
                }
              />
              <Text type="secondary" style={{ fontSize: 12 }}>
                Recommended: Keep under 160 characters
              </Text>
            </Form.Item>

            <Form.Item label="Keywords">
              <Input
                placeholder="react, typescript, seo"
                onChange={(e) =>
                  setValues({ ...values, keywords: e.target.value })
                }
              />
            </Form.Item>
          </Form>
        </Card>
      </Col>

      {/* Code Preview Panel */}
      <Col xs={24} lg={12}>
        <Card
          className="glass-card"
          title={
            <span>
              <EyeOutlined style={{ marginRight: 8, color: "#3b82f6" }} />
              Live Code Preview
            </span>
          }
          bordered={false}
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
          bodyStyle={{ flex: 1, display: "flex", flexDirection: "column" }}
        >
          <div style={{ position: "relative", flex: 1 }}>
            <div
              style={{
                position: "absolute",
                top: -10,
                right: 0,
                zIndex: 1,
              }}
            >
              <Tag color="blue">HTML5</Tag>
            </div>
            <TextArea
              className="code-editor"
              value={code}
              style={{
                height: "100%",
                resize: "none",
                borderRadius: 8,
                padding: 15,
                fontSize: 13,
                lineHeight: 1.5,
              }}
              readOnly
            />
          </div>
          <Button
            type="primary"
            block
            size="large"
            icon={<CopyOutlined />}
            style={{ marginTop: 20 }}
            onClick={handleCopy}
          >
            Copy Snippet
          </Button>
        </Card>
      </Col>
    </Row>
  );
};

export default MetaGen;
